'use client';

import React from 'react';
import { SectionTitle } from '@benzinga/core-ui';
import Peers from '../../../../../src/components/Quote/Peers';
import DefaultSidebar from '../../../../../src/components/Sidebars/DefaultSidebar';
import type { BaseQuoteProfile } from '../../../../../src/utils/quote/types';

interface PeopleAlsoWatchProps {
  profile: BaseQuoteProfile;
  symbol: string;
  /** Optional content rendered above the sidebar block (e.g. ad placeholders). */
  children?: React.ReactNode;
}

const PeopleAlsoWatch: React.FC<PeopleAlsoWatchProps> = ({ profile, symbol, children }) => {
  const hasPeers = !profile.isETF && (profile.peerSymbols?.length ?? 0) > 0;
  if (!hasPeers && !children) return null;

  return (
    <div className="w-full lg:w-3/12 flex flex-col gap-4">
      {children}
      {hasPeers && (
        <React.Suspense fallback={null}>
          <DefaultSidebar>
            <div className="w-full">
              <SectionTitle level={3} size="2xl">
                People Also Watch
              </SectionTitle>
              <Peers
                peers={profile.peers}
                peerSymbols={profile.peerSymbols}
                showTitle={false}
                symbol={symbol}
                type={profile.schedule?.type || 'REGULAR'}
              />
            </div>
          </DefaultSidebar>
        </React.Suspense>
      )}
    </div>
  );
};

export default PeopleAlsoWatch;
